import { PageEscolherMatriculaEleicaoComponent } from './../shared/layout/page-escolher-matricula-eleicao/page-escolher-matricula-eleicao.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from '../home/home.component';
import { AuthGuard } from './guards/auth.guard';
import { PageConfirmarMatriculaComponent } from '../shared/layout/page-confirmar-matricula/page-confirmar-matricula.component';
import { PageEscolherMatriculaEmprestimoComponent } from '../shared/layout/page-escolher-matricula-emprestimo/page-escolher-matricula-emprestimo.component';


const appRoutes: Routes = [

  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: 'app/area-restrita/login/login.module#LoginModule',
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  {
    path: 'confimerMatricula/:pb/:pc',
    component: PageConfirmarMatriculaComponent,
    canLoad: [AuthGuard]
  },
  {
    path: 'confimerMatriculaEmprestimo/:id',
    component: PageEscolherMatriculaEmprestimoComponent,
    canLoad: [AuthGuard]
  },
  {
    path: 'confimerMatriculaEleicao/:id',
    component: PageEscolherMatriculaEleicaoComponent,
    canLoad: [AuthGuard]
  },
  {
    path: 'pessoais',
    loadChildren: 'app/area-restrita/pessoal/pessoal.module#PessoalModule',
    canLoad: [AuthGuard],
  },
  {
    path: 'cardMenus',
    loadChildren: 'app/area-restrita/card-menu/card-menu.module#CardMenuModule',
    canLoad: [AuthGuard],
  },
  {
    path: 'financeiros',
    loadChildren: 'app/area-restrita/financeiro/financeiro.module#FinanceiroModule',
    canLoad: [AuthGuard],
  },
  {
    path: 'planos',
    loadChildren: 'app/area-restrita/planos/planos.module#PlanosModule',
    canLoad: [AuthGuard]
  },
  {
    path: 'administrativo',
    loadChildren: 'app/area-restrita/administrativo/administrativo.module#AdministrativoModule',
    canLoad: [AuthGuard]
  },
  {
    path: 'institucional',
    loadChildren: 'app/area-restrita/institucional/institucional.module#InstitucionalModule',
    canLoad: [AuthGuard]
  },
  {
    path: 'recuperarSenha',
    loadChildren: 'app/area-restrita/recuperar-senha/recuperar-senha.module#RecuperarSenhaModule'
  },
  {
    path: '**', redirectTo: '/login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/routes/app.routing.module.ts